// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import { UserMinified, UserMinifiedFromJSON, UserMinifiedToJSON } from "./";

/**
 *
 * @export
 * @interface QacConversationFeedback
 */
export interface QacConversationFeedback {
  /**
   *
   * @type {number}
   * @memberof QacConversationFeedback
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof QacConversationFeedback
   */
  message: number;
  /**
   *
   * @type {UserMinified}
   * @memberof QacConversationFeedback
   */
  givenBy?: UserMinified;
  /**
   *
   * @type {string}
   * @memberof QacConversationFeedback
   */
  rating: QacConversationFeedbackRatingEnum;
  /**
   *
   * @type {string}
   * @memberof QacConversationFeedback
   */
  reason?: QacConversationFeedbackReasonEnum;
  /**
   *
   * @type {string}
   * @memberof QacConversationFeedback
   */
  comment?: string;
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof QacConversationFeedback
   */
  createdAt: string;
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof QacConversationFeedback
   */
  updatedAt?: string;
}

export function QacConversationFeedbackFromJSON(
  json: any
): QacConversationFeedback {
  return {
    id: json["id"],
    message: json["message"],
    givenBy: !exists(json, "given_by")
      ? undefined
      : UserMinifiedFromJSON(json["given_by"]),
    rating: json["rating"],
    reason: !exists(json, "reason") ? undefined : json["reason"],
    comment: !exists(json, "comment") ? undefined : json["comment"],
    createdAt: json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
  };
}

export function QacConversationFeedbackToJSON(
  value?: QacConversationFeedback
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    message: value.message,
    given_by: UserMinifiedToJSON(value.givenBy),
    rating: value.rating,
    reason: value.reason,
    comment: value.comment,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum QacConversationFeedbackRatingEnum {
  Up = "up",
  Down = "down",
}
/**
 * @export
 * @enum {string}
 */
export enum QacConversationFeedbackReasonEnum {
  Irrelevant = "irrelevant",
  Incorrect = "incorrect",
  Offensive = "offensive",
  Other = "other",
}
